import { Chip } from '@mui/material';
import { Cancel } from '@mui/icons-material';
import { FileDownload } from '@mui/icons-material';
import { SelectAutocomplete } from '@/components';

import './PriceComparisonFilters.css';
import { PriceComparisonFiltersProps } from './PriceComparisonFilters.types';

/**
 * Renders filter controls for price comparison functionality
 * Provides hierarchical filtering by regional office, province, and brand with export capability
 *
 * @param props - The component props
 * @returns JSX element containing the price comparison filter interface
 */
export function PriceComparisonFilters({
  regionalOffices,
  provinces,
  brands,
  selectedRegionalOffice,
  selectedProvinces,
  selectedBrands,
  activeFilters,
  canExport,
  isLoading,
  onRemoveActiveFilter,
  onChangeFilter,
  onExport
}: PriceComparisonFiltersProps) {
  return (
    <div className="price-comparison-filter-card">
      <div className="price-comparison-filter-row">
        <div className="price-comparison-form-field-group">
          <label className="price-comparison-field-label">Регіональне відділення *</label>
          <SelectAutocomplete
            placeholder="Оберіть регіональне відділення..."
            options={regionalOffices}
            value={selectedRegionalOffice || ''}
            onChange={onChangeFilter('regional_office')}
          />
        </div>

        <div className="price-comparison-form-field-group">
          <label className="price-comparison-field-label">Область</label>
          <SelectAutocomplete
            options={provinces}
            value={''}
            showClearButton={selectedProvinces.length > 0}
            placeholder="Оберіть область..."
            disabled={!selectedRegionalOffice}
            onChange={onChangeFilter('province')}
            onClear={onRemoveActiveFilter('province')}
          />
        </div>

        <div className="price-comparison-form-field-group">
          <label className="price-comparison-field-label">Бренди</label>
          <SelectAutocomplete
            options={brands}
            value={''}
            showClearButton={selectedBrands.length > 0}
            placeholder="Оберіть бренд..."
            disabled={!selectedRegionalOffice}
            onChange={onChangeFilter('brand')}
            onClear={onRemoveActiveFilter('brand')}
          />
        </div>
      </div>

      {activeFilters.length > 0 && (
        <div className="price-comparison-active-filters">
          {activeFilters.map((filter, index) => (
            <Chip
              key={`${filter.key}-${filter.value}-${index}`}
              label={filter.value}
              deleteIcon={<Cancel />}
              className={`price-comparison-filter-chip ${filter.key}`}
              onDelete={onRemoveActiveFilter(filter.key, filter.value)}
            />
          ))}
        </div>
      )}

      <div className="action-buttons">
        {canExport && (
          <button className="action-btn save-btn" onClick={onExport} disabled={!selectedRegionalOffice || isLoading}>
            <FileDownload />
            Вивантажити в Excel
          </button>
        )}
      </div>
    </div>
  );
}
